import { gql } from "@apollo/client";

export const CREATE_STUDENT = gql`
  mutation CreateStudent($input: CreateStudentInput) {
    createStudent(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_STUDENT_PAGINATION = gql`
  query GetStudentPagination($page: Int, $limit: Int, $pagination: Boolean, $keyword: String, $academicYearId: String, $schoolId: String, $teacherId: String, $levelId: String, $groupId: String, $attendedStatus: String) {
  getStudentPagination(page: $page, limit: $limit, pagination: $pagination, keyword: $keyword, academic_year_id: $academicYearId, school_id: $schoolId, teacher_id: $teacherId, level_id: $levelId, group_id: $groupId, attended_status: $attendedStatus) {
    data {
      _id
      attended_status
      class_attended {
        _id
        class_id {
          _id
          academic_year_id {
            _id
            academic_year
          }
          group_id {
            _id
            group_name
          }
          level_id {
            _id
            level_name
          }
          school_id {
            _id
            school_name
            school_name_en
          }
          teacher_id {
            _id
            first_name
            last_name
            latin_name
          }
        }
      }
      current_address
      date_of_birth
      full_name_kh
      full_name_latin
      gender
      student_id
      remark
      phone_number
      drop_out_date
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

export const UPDATE_STUDENT = gql`
  mutation UpdateStudent($id: ID, $input: UpdateStudentInput) {
    updateStudent(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DELETE_STUDENT = gql`
  mutation DeleteStudent($id: ID) {
    deleteStudent(_id: $id) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_STUDENT_BY_ID = gql`
  query GetStudentById($id: ID) {
    getStudentById(_id: $id) {
      _id
      student_id
      full_name_kh
      full_name_latin
      gender
      date_of_birth
      phone_number
      current_address
      remark
    }
  }
`;

export const IMPORT_STUDENT_FROM_CSV_FILE = gql`
  mutation ImportStudentFromCSVFile(
    $academicYearId: ID
    $schoolId: ID
    $input: [ImportStudentFromCSVInput!]
  ) {
    importStudentFromCSVFile(
      academic_year_id: $academicYearId
      school_id: $schoolId
      input: $input
    ) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const CREATE_CLASS_ATTENDED = gql`
  mutation CreateClassAttended($input: ClassAttendedInput) {
    createClassAttended(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const UPDATE_CLASS_ATTENDED = gql`
  mutation UpdateClasAttended($id: ID!, $input: ClassAttendedInput) {
    updateClasAttended(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GET_CLASS_ATTENDED_BY_STUDENT = gql`
  query GetClassAttendedByStudent($studentId: ID, $academicYearId: ID) {
    getClassAttendedByStudent(
      student_id: $studentId
      academic_year_id: $academicYearId
    ) {
      _id
      student_id {
        _id
        student_id
        full_name_kh
        full_name_latin
        gender
        date_of_birth
        phone_number
        current_address
        remark
      }
      class_id {
        _id
        academic_year_id {
          _id
          academic_year
          remark
        }
        school_id {
          _id
          school_name
          school_name_en
          remark
        }
        level_id {
          _id
          level_name
          remark
        }
        group_id {
          _id
          group_name
          remark
        }
        teacher_id {
          _id
          last_name
          first_name
          latin_name
          role
          gender
          phone_number
          email
          is_enabled
        }
        remark
      }
      is_last_class
      join_date
      is_finished_class
      certificate_offer_status
      is_drop_out
      drop_out_date
      is_change_class
      change_date
      previous_class_id {
        _id
        academic_year_id {
          _id
          academic_year
          remark
        }
        group_id {
          _id
          group_name
          remark
        }
        level_id {
          _id
          level_name
          remark
        }
        remark
        school_id {
          _id
          school_name
          school_name_en
          remark
        }
        teacher_id {
          _id
          last_name
          first_name
          latin_name
          role
          gender
          phone_number
          email
          is_enabled
        }
      }
    }
  }
`;

export const CHANGE_CLASS = gql`
  mutation ChangeClass($id: ID!, $changeToClassId: ID!) {
    changeClass(_id: $id, change_to_class_id: $changeToClassId) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const DROP_OUT_FROM_CLASS = gql`
  mutation DropFromClass($id: ID!, $input: DropOutInput) {
    dropFromClass(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const FINISH_CLASS = gql`
  mutation FinishClass($id: ID!, $input: FinishClassInput) {
    finishClass(_id: $id, input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;

export const GENERATE_NEW_CLASS_ATTENDED = gql`
  mutation GenerateNewClassAttended($input: CreateNewClassforStudentInput) {
    generateNewClassAttended(input: $input) {
      is_success
      message {
        message_en
        message_kh
      }
    }
  }
`;



export const DELETE_MANY_STUDENTS = gql`
mutation DeleteManyStudent($academicYearId: ID!, $schoolId: ID!, $levelId: ID!, $groupId: ID) {
  deleteManyStudent(academic_year_id: $academicYearId, school_id: $schoolId, level_id: $levelId, group_id: $groupId) {
    is_success
    message {
      message_en
      message_kh
    }
  }
}
`;
